import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ROUTES } from "../lib/journeys";
import { Reveal, useSeo } from "../lib/ui";
import { EcosystemFramework } from "../components/Ecosystem";
import { RecommendedEntities } from "../components/RecommendedEntities";
import { ExecutiveSummary } from "../components/ExecutiveSummary";

/** One of the four routes into the platform: a curated index of pages that already exist. */
export default function RouteLanding() {
  const { pathname } = useLocation();
  const route = ROUTES.find((r) => `/${r.slug}` === pathname) || ROUTES[0];

  useSeo({
    title: `${route.title} — KickStartKenyaFootball`,
    description: route.blurb,
  });

  return (
    <div className="bg-black pb-24 pt-12 md:pt-16" data-testid={`route-landing-${route.slug}`}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <p className="overline text-ochre">Route {route.n} of 04</p>
        <h1 className="display-1 mt-5 max-w-4xl">{route.title}</h1>
        <p className="body-copy mt-6 max-w-3xl">{route.blurb}</p>

        <div className="mt-14 grid gap-px sm:grid-cols-2 lg:grid-cols-3" data-testid="route-links">
          {route.links.map(([label, to], i) => (
            <Reveal key={to} delay={Math.min(i * 0.04, 0.24)}>
              <Link
                to={to}
                data-testid={`route-link-${to.replace(/\//g, "-")}`}
                className="group flex h-full flex-col justify-between border border-zinc-900 bg-black p-6 transition-colors hover:bg-[#0b0b0b] md:p-7"
              >
                <p className="font-display text-lg uppercase leading-tight tracking-tight text-white group-hover:text-ochre">
                  {label}
                </p>
                <span className="mono mt-6 inline-flex items-center gap-1.5 text-[0.52rem] uppercase tracking-[0.16em] text-zinc-500 group-hover:text-ochre">
                  Open <ArrowUpRight size={10} />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap gap-3" data-testid="route-siblings">
          {ROUTES.filter((r) => r.slug !== route.slug).map((r) => (
            <Link
              key={r.slug}
              to={`/${r.slug}`}
              className="mono border border-zinc-800 px-5 py-3 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-400 transition-colors hover:border-ochre hover:text-ochre"
            >
              {r.title}
            </Link>
          ))}
        </div>
      </div>

      {route.slug === "partner" ? <ExecutiveSummary /> : null}
      {route.slug === "partner" ? <RecommendedEntities /> : null}
      {route.slug === "partner" || route.slug === "national-plan" ? <EcosystemFramework compact /> : null}
    </div>
  );
}
